<template>
  <div :class="{'page_content--loading': !reportData}">
    <div class="vx-row justify-end">
      <div class="vx-col">
        <switch-field
          v-model="innerFiltered"
          class="mt-4 mb-4"
          name="フィルター表示"
          label="フィルター表示"
        />
      </div>
    </div>
    <div
      v-if="showFilters"
      class="vx-row justify-end"
    >
      <div
        style="z-index: 9998;"
        class="vx-col"
      >
        <div class="filter">
          <sales-filter
            v-model="selectedTitles"
            class="w-48 mb-1 mr-1"
            :options="titleOptions"
            :no-option-text="salesByTitleFilterNoOptionText"
            placeholder="商品名"
          />
          <sales-filter
            v-model="selectedAsins"
            class="w-48 mb-1 mr-1"
            :options="asinOptions"
            :no-option-text="salesByAsinFilterNoOptionText"
            placeholder="ASIN"
          />
          <sales-filter
            v-model="selectedParentAsins"
            class="w-48 mb-1 mr-1"
            :options="parentAsinOptions"
            :no-option-text="salesByParentAsinFilterNoOptionText"
            placeholder="親ASIN"
          />
          <sales-filter
            v-model="selectedBrands"
            class="w-48 mb-1 mr-1"
            :options="brandOptions"
            :no-option-text="salesByBrandFilterNoOptionText"
            placeholder="ブランド"
          />
          <sales-filter
            v-model="selectedSubCategoryNames"
            class="w-48 mb-1"
            :options="subCategoryNameOptions"
            :no-option-text="salesBySubCategoryNameFilterNoOptionText"
            placeholder="サブカテゴリー名"
          />
        </div>
      </div>
      <div
        class="vx-col"
        style="z-index: 9997;"
      >
        <div class="filter">
          <sales-filter
            v-model="selectedSellerCategories"
            class="w-48 mb-1 mr-1"
            :options="sellerCategoryOptions"
            :no-option-text="salesBySellerCategoryFilterNoOptionText"
            placeholder="出品者カテゴリー1"
          />
          <sales-filter
            v-model="selectedSellerCategories2"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory2Options"
            :no-option-text="salesBySellerCategory2FilterNoOptionText"
            placeholder="出品者カテゴリー2"
          />
          <sales-filter
            v-model="selectedSellerCategories3"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory3Options"
            :no-option-text="salesBySellerCategory3FilterNoOptionText"
            placeholder="出品者カテゴリー3"
          />
          <sales-filter
            v-model="selectedSellerCategories4"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory4Options"
            :no-option-text="salesBySellerCategory4FilterNoOptionText"
            placeholder="出品者カテゴリー4"
          />
          <sales-filter
            v-model="selectedSellerCategories5"
            class="w-48 mb-1"
            :options="sellerCategory5Options"
            :no-option-text="salesBySellerCategory5FilterNoOptionText"
            placeholder="出品者カテゴリー5"
          />
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-1/2">
        <section-title title="Revenue" />
        <vx-card>
          <revenue-chart
            :class="{'min-h-full': !reportData}"
            :report="reportData.monthly"
            label-field="month"
            :height="400"
            :precision="2"
          />
        </vx-card>
      </div>
      <div class="vx-col w-1/2">
        <section-title title="Subscription" />
        <vx-card>
          <subscription-revenue-chart
            :class="{'min-h-full': !reportData}"
            :report="reportData.sellerSubscription"
            label-field="month"
            :height="400"
            :precision="2"
          />
        </vx-card>
      </div>
    </div>
    <section-title
      title="Funnel"
      class="mt-8"
    />
    <div class="vx-row">
      <div class="vx-col w-1/2">
        <vx-card>
          <quantity-shipped-average-sales-chart
            :class="{'min-h-full': !reportData}"
            :report="reportData.monthly"
            label-field="month"
            :height="400"
            :precision="2"
          />
        </vx-card>
      </div>
      <div class="vx-col w-1/2">
        <vx-card>
          <order-rate-pageviews-chart
            :class="{'min-h-full': !reportData}"
            :report="reportData.monthly"
            label-field="month"
            :height="400"
            :precision="2"
          />
        </vx-card>
      </div>
    </div>
    <section-title
      title="Category"
      class="mt-8"
    />
    <div
      v-if="reportData"
      class="vx-row"
    >
      <div class="vx-col w-1/2">
        <vx-card>
          <monthly-sales-by-sub-category-name-chart
            :class="{'min-h-full': !reportData}"
            :report="reportData.monthlySalesBySubCategoryName"
            :height="400"
          />
        </vx-card>
      </div>
      <div class="vx-col w-1/2">
        <vx-card>
          <monthly-sales-by-seller-category-chart
            :class="{'min-h-full': !reportData}"
            :report="reportData.monthlySalesBySellerCategory"
            :height="400"
          />
        </vx-card>
      </div>
    </div>
    <section-title
      title="Advertising"
      class="mt-8"
    />
    <div
      v-if="reportData"
      class="vx-row px-4"
    >
      <vx-card>
        <roas-chart
          :class="{'min-h-full': !reportData}"
          :report="reportData.monthly"
          label-field="month"
          :height="400"
          :precision="2"
        />
      </vx-card>
    </div>
    <section-title
      title="Metrics"
      class="mt-8"
    />
    <div class="vx-row">
      <div class="vx-col w-1/2">
        <vx-card>
          <spa-cpa-chart
            :report="reportData.monthly"
            :height="400"
            label-field="month"
          />
        </vx-card>
      </div>
      <div class="vx-col w-1/2">
        <vx-card>
          <cpc-cvr-chart
            :report="reportData.monthly"
            label-field="month"
            :height="400"
            :precision="2"
          />
        </vx-card>
      </div>
    </div>
    <section-title
      title="Other"
      class="mt-8"
    />
    <div
      v-if="reportData"
      class="vx-row"
    >
      <div class="vx-col w-1/2">
        <vx-card>
          <cartbox-rate-chart
            :report="reportData.monthly"
            label-field="month"
            :height="400"
            :precision="2"
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import SectionTitle from '@/components/SectionTitle'
import SalesFilter from '@/components/SalesFilter'
import RoasChart from '@/user/components/charts/RoasChart'
import QuantityShippedAverageSalesChart from '@/user/components/charts/QuantityShippedAverageSalesChart'
import CartboxRateChart from '@/user/components/charts/CartboxRateChart'
import CpcCvrChart from '@/user/components/charts/CpcCvrChart'
import SpaCpaChart from '@/user/components/charts/SpaCpaChart'
import RevenueChart from '@/user/components/charts/RevenueChart'
import SubscriptionRevenueChart from '@/user/components/charts/SubscriptionRevenueChart'
import OrderRatePageviewsChart from '@/user/components/charts/OrderRatePageviewsChart'
import MonthlySalesBySubCategoryNameChart from '@/user/components/charts/MonthlySalesBySubCategoryNameChart'
import MonthlySalesBySellerCategoryChart from '@/user/components/charts/MonthlySalesBySellerCategoryChart'
import SwitchField from '@/components/fields/SwitchField'
import { debounce } from '@/utils'

export default {
  components: {
    MonthlySalesBySellerCategoryChart,
    MonthlySalesBySubCategoryNameChart,
    OrderRatePageviewsChart,
    RevenueChart,
    SubscriptionRevenueChart,
    CpcCvrChart,
    CartboxRateChart,
    QuantityShippedAverageSalesChart,
    RoasChart,
    SalesFilter,
    SectionTitle,
    SpaCpaChart,
    SwitchField
  },
  data () {
    return {
      selectedAsins: [],
      selectedTitles: [],
      selectedBrands: [],
      selectedSubCategoryNames: [],
      selectedParentAsins: [],
      selectedSellerCategories: [],
      selectedSellerCategories2: [],
      selectedSellerCategories3: [],
      selectedSellerCategories4: [],
      selectedSellerCategories5: [],
      availableDates: undefined,
      filtered: false,
      showFilters: false
    }
  },
  computed: {
    ...mapState('trend', ['requestingStatus', 'reportData']),
    ...mapState('account', ['activeAccount']),
    salesByTitleFilterNoOptionText () {
      return this.requestingStatus.salesByTitle ? 'Loading...' : '候補がありません'
    },
    salesByAsinFilterNoOptionText () {
      return this.requestingStatus.salesByAsin ? 'Loading...' : '候補がありません'
    },
    salesByParentAsinFilterNoOptionText () {
      return this.requestingStatus.salesByParentAsin ? 'Loading...' : '候補がありません'
    },
    salesByBrandFilterNoOptionText () {
      return this.requestingStatus.adSalesByBrand ? 'Loading...' : '候補がありません'
    },
    salesBySubCategoryNameFilterNoOptionText () {
      return this.requestingStatus.salesBySubCategoryName ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategoryFilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory2FilterNoOptionText () {
      return this.requestingStatus.adSalesBySellerCategory2 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory3FilterNoOptionText () {
      return this.requestingStatus.adSalesBySellerCategory3 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory4FilterNoOptionText () {
      return this.requestingStatus.adSalesBySellerCategory4 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory5FilterNoOptionText () {
      return this.requestingStatus.adSalesBySellerCategory5 ? 'Loading...' : '候補がありません'
    },
    parentAsinOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesByParentAsin.map(item => ({
        text: item.parentAsin,
        value: item.parentAsin,
        sales: item.adSales
      }))
    },
    sellerCategoryOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesBySellerCategory.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.adSales
      }))
    },
    sellerCategory2Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesBySellerCategory2.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.adSales
      }))
    },
    sellerCategory3Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesBySellerCategory3.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.adSales
      }))
    },
    sellerCategory4Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesBySellerCategory4.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.adSales
      }))
    },
    sellerCategory5Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesBySellerCategory5.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.adSales
      }))
    },
    brandOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesByBrand.map(item => ({
        text: item.brand,
        value: item.brand,
        sales: item.adSales
      }))
    },
    asinOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesByAsin.map(item => ({
        text: item.asin,
        value: item.asin,
        sales: item.adSales
      }))
    },
    titleOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesByTitle.map(item => ({
        text: item.title,
        value: item.title,
        sales: item.adSales
      }))
    },
    subCategoryNameOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.adSalesBySubCategoryName.map(item => ({
        text: item.subcategoryName,
        value: item.subcategoryName,
        sales: item.adSales
      }))
    },
    selectedBrandValues () {
      return this.selectedBrands.map(selectedCategoryName => selectedCategoryName.value)
    },
    selectedAsinValues () {
      return this.selectedAsins.map(selectedAsin => selectedAsin.value)
    },
    selectedTitleValues () {
      return this.selectedTitles.map(selectedTitle => selectedTitle.value)
    },
    selectedSubCategoryNameValues () {
      return this.selectedSubCategoryNames.map(selectedSubCategoryName => selectedSubCategoryName.value)
    },
    selectedParentAsinValues () {
      return this.selectedParentAsins.map(selectedParentAsin => selectedParentAsin.value)
    },
    selectedSellerCategoryValues () {
      return this.selectedSellerCategories.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory2Values () {
      return this.selectedSellerCategories2.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory3Values () {
      return this.selectedSellerCategories3.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory4Values () {
      return this.selectedSellerCategories4.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory5Values () {
      return this.selectedSellerCategories5.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    innerFiltered: {
      get () {
        return this.filtered
      },
      set (val) {
        this.filtered = val
        this.showFilters = val
      }
    }
  },
  watch: {
    selectedAsins: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedTitles: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedBrands: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSubCategoryNames: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedParentAsins: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories2: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories3: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories4: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories5: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    activeAccount: {
      handler () {
        this.resetFilters()
      }
    }
  },
  created () {
    this.getReport()
  },
  methods: {
    resetFilters () {
      this.selectedAsins = []
      this.selectedTitles = []
      this.selectedBrands = []
      this.selectedSubCategoryNames = []
      this.selectedParentAsins = []
      this.selectedSellerCategories = []
      this.selectedSellerCategories2 = []
      this.selectedSellerCategories3 = []
      this.selectedSellerCategories4 = []
      this.selectedSellerCategories5 = []
    },
    filterReport: debounce(function () {
      this.getReport()
    }, 1000),
    ...mapActions('trend', ['fetchReport']),
    async getReport () {
      let startDay = moment().startOf('month')
      if (startDay.date() === 1) {
        startDay = moment().subtract(1, 'days').startOf('month')
      }
      startDay = startDay.subtract(13, 'months').format('YYYY-MM-DD').split('T')[0]
      const endDay = moment().subtract(1, 'days').format('YYYY-MM-DD').split('T')[0]
      const params = {
        start_day: startDay,
        end_day: endDay
      }
      if (this.selectedAsinValues) {
        params['asin'] = this.selectedAsinValues
      }
      if (this.selectedTitleValues) {
        params['title'] = this.selectedTitleValues
      }
      if (this.selectedBrandValues) {
        params['brand'] = this.selectedBrandValues
      }
      if (this.selectedSubCategoryNameValues) {
        params['subcategory_name'] = this.selectedSubCategoryNameValues
      }
      if (this.selectedParentAsinValues) {
        params['parent_asin'] = this.selectedParentAsinValues
      }
      if (this.selectedSellerCategoryValues) {
        params['seller_category'] = this.selectedSellerCategoryValues
      }
      if (this.selectedSellerCategory2Values) {
        params['seller_category2'] = this.selectedSellerCategory2Values
      }
      if (this.selectedSellerCategory3Values) {
        params['seller_category3'] = this.selectedSellerCategory3Values
      }
      if (this.selectedSellerCategory4Values) {
        params['seller_category4'] = this.selectedSellerCategory4Values
      }
      if (this.selectedSellerCategory5Values) {
        params['seller_category5'] = this.selectedSellerCategory5Values
      }

      const actions = [
        'monthly',
        'monthlySalesBySubCategoryName',
        'monthlySalesBySellerCategory',
        'adSalesByTitle',
        'adSalesByAsin',
        'adSalesByParentAsin',
        'adSalesByBrand',
        'adSalesByCategoryName',
        'adSalesBySubCategoryName',
        'adSalesBySellerCategory',
        'adSalesBySellerCategory2',
        'adSalesBySellerCategory3',
        'adSalesBySellerCategory4',
        'adSalesBySellerCategory5',
        'sellerSubscription'
      ]

      await Promise.all(actions.map(action => {
        return new Promise((resolve) => {
          try {
            resolve(this.fetchReport({
              ...params,
              action
            }))
          } catch (e) {
            console.log(e)
          }
        })
      }))

    }
  }
}
</script>

<style lang="scss" scoped>
.page_content--loading .vx-card {
  min-height: 127.875px;
}
</style>

<style>
div.filter {
    display: flex;
    flex-wrap: wrap;
}
.sales-filter .multiselect__tags,
.sales-filter .multiselect__tags .multiselect__input,
.sales-filter .multiselect__content-wrapper {
  font-size: 13px;
}
</style>
